export default {"src":"/_next/static/media/Plane-Animation-Desktop.3b2bbdc6.gif","height":160,"width":1920};